/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from './axios';
import { Identity } from './onboarding';

export type CheckInvitationTokenRes = {
  emailAddress: string;
  businessLegalName: string;
  phoneNumber?: string;
  authActions: {
    setPassword?: boolean;
    smsOtp?: boolean;
  };
};

export const checkInvitationToken = (token: string) => {
  return axios
    .post<CheckInvitationTokenRes>('auth/invitation/check', { token })
    .then((res) => res.data);
};

export const confirmInvitationEmail = (token: string) => {
  return axios.post<Identity>('auth/invitation/confirmEmail', { token }).then((res) => res.data);
};

export const acceptInvitation = (token: string) => {
  return axios.post<void>('auth/invitation/acceptInvitation', { token }).then((res) => res.data);
};
